(function() {
    'use strict';

    angular
        .module('wagEventReg',
            [
                'ngCookies',
                'ngTouch',
                'ngSanitize',
                'ngMessages',
                'ngAria',
                'ngAnimate',
                'restangular',
                'ui.router',
                'ngMaterial',
                'gettext',
                'smoothScroll',
                'toaster',
                'angular-google-analytics'
            ]);

})();

(function() {
    'use strict';

    angular
        .module('wagEventReg')
        .directive('waInput', waInput);

    /** @ngInject */
    function waInput($compile, $rootScope, gettextCatalog) {
        var numberRegex = new RegExp('^\\d{1,5}$');
        var dateRegex = new RegExp('^([0]?[1-9]|[1|2][0-9]|[3][0|1])[.]([0]?[1-9]|[1][0-2])[.]([0-9]{4})$');
        var radioInputs = 0;
        // @@TODO: Could be part of the external config, a linkage to a specific purchasable
        // item has to also be provided in that case (and the logic has to be written for that)
        var watchedInputs = [
            'seasonPass',
            'birthDate',
            'dinner'
        ];

        var directive = {
            restrict: 'E',
            // Create a child scope, inheriting the parent scope
            scope: true,
            link: link
        };

        return directive;


        function link(scope, el, attrs) {
            scope.register = scope.$parent.register;
            scope.formIndex = attrs.formIndex;

            var input = {};
            scope.$watch(attrs.ngModel, function(newValue) {
                if (newValue && newValue.id) {
                    compileInputField(scope, el, newValue);
                }
            });
        }

        function compileInputField(scope, el, input) {
            if (!input || !input.type) {
                return;
            }
            var html,
                name = 'participants' + input.id + String(scope.formIndex),
                model = 'participants[' + scope.formIndex + '].' + input.id,
                participantModel = 'register.' + model;

            var dinnerDescription = input.id === 'dinner'
                ? '<strong class="registered-amount__count">' + gettextCatalog.getString('Dinner, seats available') + ' {{ register.dinnerReservationsString }}</strong>'
                : '';

            var listener = setListener(input.id);

            if (input.type === 'radio') {
                radioInputs += 1;
                scope.register.radioOptions[radioInputs] = input.options;
                html =
                    '<md-radio-group' + listener + 'ng-model="' + participantModel + '" class="md-primary" ng-required="' + input.required + '">' +
                        dinnerDescription +
                        '<label><span ng-if="' + input.required + '">* </span>' + input.label[$rootScope.headerLanguage] + '</label>' +
                        '<md-radio-button ng-repeat="option in register.radioOptions[' + radioInputs + ']" ng-disabled="inputsDisabled"' +
                            'ng-value="option.value">' +
                            '{{option.label[headerLanguage]}}<br/>' +
                        '</md-radio-button>' +
                    '</md-radio-group>';
            }
            else {
                var projectedType = getProjectedType(input.type);

                html =
                    '<md-input-container>' +
                        '<label for="' + model + '"><span ng-if="' + input.required + '">* </span>' + input.label[$rootScope.headerLanguage] + '</label>' +
                        '<input ng-model="' + participantModel + '"' + listener + projectedType + 'ng-disabled="inputsDisabled" name="' + name + '" id="' + model + '"' + (input.maxLength ? ' md-maxlength="' + input.maxLength + '"': '') + '  ng-required="' + input.required + '">' +
                        '<div ng-if="' + '\'' + input.type + '\'' + '===\'text\' && registrationForm.' + name + '.$dirty" ng-messages="registrationForm.' + name + '.$error" class="error-messages">' +
                            '<div ng-message="required">This is required.</div>' +
                            '<div ng-message="md-maxlength">' + input.label[$rootScope.headerLanguage] + ' can be no more than ' + input.maxLength + ' characters.</div>' +
                        '</div>' +
                        // For <input type !== 'text'>
                        '<div ng-if="' + '\'' + input.type + '\'' + '!==\'text\' && registrationForm.' + name + '.$dirty" ng-messages="registrationForm.' + name + '.$error" class="error-messages">' +
                            '<div ng-message="required">This is required.</div>' +
                            '<div ng-message="md-maxlength">' + input.label[$rootScope.headerLanguage] + ' can be no more than ' + input.maxLength + ' characters.</div>' +
                            '<div ng-if="' + '\'' + input.type + '\'' + '===\'date\'" ng-message="pattern">Examples: 13.12.1979 | 30.3.2004</div>' +
                    '</md-input-container>';
            }
            el.append(html);
            $compile(el.contents())(scope);
        }

        function getProjectedType(type) {
            if (!type) {
                return '';
            }
            switch(type) {
                case 'number':
                    return 'ng-pattern="' + numberRegex + '"';
                case 'date':
                    return 'type="text" ng-pattern="' + dateRegex + '"';
                default:
                    return 'type="' + type + '"';
            }
        }

        // Returns the part of template code that calls the controller function to execute
        // if the given id is defined to be listened on. Used to update shoppingCart
        function setListener(inputId) {
            return watchedInputs.indexOf(inputId) !== -1 ? ' ng-change="register.updateCart(form.event)" ' : ' ';
        }
    }

})();

(function() {
    'use strict';

    angular.module('wagEventReg').controller('ThankYouController', ThankYouController);

    /** @ngInject */
    function ThankYouController(
        $location,
        $rootScope,
        $state,
        $window,
        gettextCatalog,
        toaster,
        participantService,
        paymentService,
        shoppingCart,
        wagApi
    ) {
        var vm = this;

        init();

        function init() {
            register();

            // Purge the stored session when the user has completed the payment flow.
            $window.sessionStorage.clear();
            // console.log('purged');
        }

        function register() {
            var urlPath = $location.url();
            var hasbangIndex = urlPath.lastIndexOf('#');
            var paymentToken = urlPath.slice(hasbangIndex + 1);

            if (hasbangIndex === -1 || !paymentToken) {
                return $state.go('app.register');
            }

            // Replace the url to lose the token and guard against reloads.
            $location.url('/thank-you');

            // console.log('uuid in thank-you ctrl', paymentService.getUUID());
            wagApi
                .register(
                    participantService.formatParticipantsForBackend(),
                    shoppingCart.getTotalPrice(),
                    paymentToken,
                    paymentService.getUUID()
                )
                .then(registrationSucceeded, registrationFailed);
        }

        function registrationSucceeded(response) {
            if (response.status !== 'success') {
                return registrationFailed(response);
            }

            toaster.success({
                title: gettextCatalog.getString('Registration successful') + ',',
                body: gettextCatalog.getString('thank you!'),
            });
            participantService.emptyParticipantList();
            $rootScope.inputsDisabled = false;
        }

        function registrationFailed(response) {
            toaster.error(gettextCatalog.getString('Registration failed. You were not charged.'));

            $state.go('app.register');
        }
    }
})();

(function() {
    'use strict';

    angular.module('wagEventReg').factory('wagApi', WagApi);

    /** @ngInject */
    function WagApi(API_BASE_URL, $http, $rootScope) {
        var METHOD_GET = 'GET';
        var METHOD_POST = 'POST';

        return {
            SUCCESS: 'success',
            ERROR: 'error',

            getEventConfig: getEventConfig,
            initWebPayment: initWebPayment,
            joinWaitingList: joinWaitingList,
            register: register,
            validateRegistration: validateRegistration,
        };

        function makeRequest(endpoint, method, params) {
            $rootScope.showLoadingAnimation = true;
            $rootScope.headerLanguage =
                $rootScope.activeLanguage && $rootScope.activeLanguage.length >= 2 ? $rootScope.activeLanguage.substring(0, 2) : '';

            var request = {
                method: method,
                url: API_BASE_URL + endpoint,
                headers: {
                    'Accept-language': $rootScope.headerLanguage || 'de',
                },
            };

            if (method === METHOD_POST) {
                request.data = params;
            } else {
                request.params = params;
            }

            return $http(request).then(
                function(response) {
                    $rootScope.showLoadingAnimation = false;
                    // Parse away the extra data property and one level
                    // of depth $http adds to the promise response
                    return response.data;
                },
                function(response) {
                    $rootScope.showLoadingAnimation = false;
                    return response;
                }
            );
        }

        function getEventConfig(eventId) {
            var endpoint = 'events/data',
                params = {
                    eventId: eventId,
                };

            return makeRequest(endpoint, METHOD_GET, params);
        }

        function joinWaitingList(eventId, person) {
            var endpoint = 'events/waiting-list',
                params = {
                    // eventId: $rootScope.eventId,
                    eventId: eventId,
                    email: person.email,
                };

            // Not required fields
            if (person.name) {
                params.name = person.name;
            }

            return makeRequest(endpoint, METHOD_POST, params);
        }

        function initWebPayment(amount, language, description, anonymousId, returnUrls) {
            var endpoint = 'saferpay/init-web-payment',
                params = {
                    amount: amount,
                    language: language,
                    description: description,
                    returnUrls: returnUrls,
                    anonymousId: anonymousId,
                };

            return makeRequest(endpoint, METHOD_POST, params);
        }

        function validateRegistration(participants, totalPrice) {
            var endpoint = 'events/validate-registration',
                params = {
                    participants: participants,
                    totalPrice: totalPrice,
                };

            return makeRequest(endpoint, METHOD_POST, params);
        }

        function register(participants, totalPrice, paymentToken, anonymousId) {
            var endpoint = 'events/register',
                params = {
                    participants: participants,
                    anonymousId: anonymousId,
                };

            // Not required fields
            if (typeof totalPrice !== 'undefined') {
                params.totalPrice = totalPrice;
            }
            if (typeof paymentToken !== 'undefined') {
                params.paymentToken = paymentToken;
            }

            return makeRequest(endpoint, METHOD_POST, params);
        }
    }
})();

(function() {
    'use strict';

    angular.module('wagEventReg').factory('shoppingCart', ShoppingCart);

    /** @ngInject */
    function ShoppingCart($rootScope, $window, moment) {
        var cart = {
            items: [],
            totalPrice: 0,
        };

        function init() {
            rehydrateAppState();
        }

        init();

        return {
            cart: cart,

            getTotalPrice: getTotalPrice,
            updateCart: updateCart,
            isEmpty: isEmpty,
            emptyCart: emptyCart,
        };

        function getTotalPrice() {
            return cart.totalPrice;
        }

        function rehydrateAppState() {
            var fifteenMinutesAgo = moment().subtract(15, 'minutes');
            var sessionTimestamp = angular.fromJson($window.sessionStorage.getItem('sessionTimestamp'));
            if (moment(sessionTimestamp).isBefore(fifteenMinutesAgo)) {
                console.log('too old session shopping cart');
                return $window.sessionStorage.clear();
            }

            var storedCart = angular.fromJson($window.sessionStorage.getItem('cart'));
            if (storedCart) {
                cart = storedCart;
                console.log('rehydrated cart');
            }
        }

        // Update the whole cart based on the participants
        function updateCart(items) {
            emptyCart();
            for (var i = 0; i < items.length; i++) {
                addItem(items[i].id, items[i].label[$rootScope.headerLanguage], items[i].price);
            }
        }

        // Add one item to cart
        function addItem(id, label, price) {
            // Increase quantity if item already found
            for (var i = 0; i < cart.items.length; i++) {
                if (cart.items[i].id === id) {
                    if (cart.items[i].price !== price) {
                        console.log('Price in cart differs from the one to be added. Item id: ' + id);
                        return false;
                    }
                    cart.items[i].quantity += 1;
                    cart.totalPrice += price;
                    return true;
                }
            }
            // Not found yet. Let's add it.
            cart.items.push({
                id: id,
                label: label,
                price: price,
                quantity: 1,
            });
            cart.totalPrice += price;
            return true;
        }

        // Check if cart is empty
        function isEmpty() {
            return cart.items.length === 0 || cart.totalPrice === 0;
        }

        // Empty the whole cart
        function emptyCart() {
            cart.items = [];
            cart.totalPrice = 0;
        }
    }
})();

(function() {
    'use strict';

    angular.module('wagEventReg').factory('registrationFormService', RegistrationFormService);

    /** @ngInject */
    function RegistrationFormService($q, $rootScope, wagApi) {
        var formConfig = {},
            formConfigReady = false,
            onGoingRequest = false,
            configGetRequest,
            secondEventConfig,
            thirdEventConfig,
            fourthEventConfig;

        init();

        return {
            getCorrectEventConfig: getCorrectEventConfig,
            getDinnerReservationsString: getDinnerReservationsString,
            getEventDate: getEventDate,
            getEventConfig: getEventConfig,
            getParticipants: getParticipants,
            getMaxParticipants: getMaxParticipants,
            getSecondEventConfig: getSecondEventConfig,
            getThirdEventConfig: getThirdEventConfig,
            getFourthEventConfig: getFourthEventConfig,
            isFreeEvent: isFreeEvent,
            isSoldOut: isSoldOut,
        };

        function init() {
            getEventConfig();
        }

        function getDinnerReservationsString() {
            if (!formConfig) {
                return '';
            }

            var maxSeats = formConfig.dinnerReservations.max;
            var currentReservations = 0;

            currentReservations += formConfig.dinnerReservations.current;
            currentReservations += secondEventConfig.dinnerReservations.current;
            currentReservations += thirdEventConfig.dinnerReservations.current;
            currentReservations += fourthEventConfig.dinnerReservations.current;

            var seatsLeft = maxSeats - currentReservations;
            if (seatsLeft < 0) {
                seatsLeft = 0;
            }
            // All events have the same max conf.
            return seatsLeft + ' / ' + maxSeats;
        }

        function getEventDate(id) {
            return formConfig.id === id ? formConfig.eventDate : secondEventConfig.eventDate;
        }

        // Returns a promise
        function getEventConfig() {
            if (!_.isEmpty(formConfig)) {
                return $q.when(formConfig);
            }
            if (onGoingRequest) {
                return configGetRequest;
            }

            onGoingRequest = true;
            var primaryEvent = wagApi.getEventConfig($rootScope.eventId);
            var secondEvent = wagApi.getEventConfig($rootScope.secondEventId);
            var thirdEvent = wagApi.getEventConfig($rootScope.thirdEventId);
            var fourthEvent = wagApi.getEventConfig($rootScope.fourthEventId);

            configGetRequest = $q
                .all([primaryEvent, secondEvent, thirdEvent, fourthEvent])
                .then(getEventConfigSucceeded, getEventConfigFailed);

            return configGetRequest;

            function getEventConfigSucceeded(response) {
                onGoingRequest = false;
                primaryEvent = response[0].data;
                secondEventConfig = response[1].data;
                thirdEventConfig = response[2].data;
                fourthEventConfig = response[3].data;

                formConfig = primaryEvent;
                formConfigReady = true;

                return formConfig;
            }

            function getEventConfigFailed(response) {
                onGoingRequest = false;
                console.log('getEventConfigFailed, response:', response);
                return $q.reject(response);
            }
        }

        function getCorrectEventConfig(eventId) {
            if (eventId === secondEventConfig.id) {
                return secondEventConfig;
            } else if (eventId === thirdEventConfig.id) {
                return thirdEventConfig;
            } else if (eventId === fourthEventConfig.id) {
                return fourthEventConfig;
            }

            return formConfig;
        }

        function getMaxParticipants(eventId) {
            return getCorrectEventConfig(eventId).participants.max;
        }

        function getParticipants(eventId) {
            return getCorrectEventConfig(eventId).participants.current;
        }

        function getSecondEventConfig() {
            return secondEventConfig;
        }

        function getThirdEventConfig() {
            return thirdEventConfig;
        }

        function getFourthEventConfig() {
            return fourthEventConfig;
        }

        function isFreeEvent(eventId) {
            if (!formConfigReady) {
                console.log('RegistrationFormService.isFreeEvent() called before config was ready!');
                return false;
            }

            return getCorrectEventConfig(eventId).isFree;
        }

        function isSoldOut(eventId) {
            if (!formConfigReady) {
                console.log('RegistrationFormService.isSoldOut() called before config was ready!');
                return true;
            }

            return getMaxParticipants(eventId) - getParticipants(eventId) <= 0;
        }
    }
})();

(function() {
    'use strict';

    angular.module('wagEventReg').factory('priceFilterService', PriceFilterService);

    /** @ngInject */
    function PriceFilterService(moment, registrationFormService) {
        // var eventConfig = {};

        function init() {
            // registrationFormService.getEventConfig().then(function(event) {
            //     eventConfig = event;
            // });
        }

        // PRICE TABLE FILTERING

        // Age applies as it is in the end of the previous year
        var _ageFilter = function(filterParams, fields) {
            // The field birthDate should exist
            if (!fields.hasOwnProperty('birthDate')) {
                return false;
            }
            // Is it empty?
            if (fields.birthDate === '') {
                return false;
            }
            // Let's get the birth date
            var birth = moment(fields.birthDate, 'DD.MM.YYYY');
            if (!birth.isValid()) {
                console.log('ageFilter: Participant birthDate is not valid: ' + fields.birthDate);
                return false;
            }

            var eventDate = moment(registrationFormService.getEventDate(fields.event)).tz('Europe/Zurich');

            var age = eventDate.diff(birth, 'years');

            // Let's see if the age fits in with the min & max properties
            return (
                (!filterParams.hasOwnProperty('min') || filterParams.min <= age) &&
                (!filterParams.hasOwnProperty('max') || filterParams.max >= age)
            );
        };

        var _seasonPassFilter = function(filterParams, fields) {
            // The field should exist
            if (!fields.hasOwnProperty('seasonPass')) {
                return false;
            }
            // Is it empty?
            if (fields.seasonPass === '') {
                return false;
            }
            // Let's see if it matches
            return filterParams.value === fields.seasonPass;
        };

        var dinnerFilter = function(filterParams, fields) {
            return fields.dinner;
        };

        function _filterMatches(filter, participantFields) {
            switch (filter.id) {
                case 'age':
                    return _ageFilter(filter.params, participantFields);
                case 'seasonPass':
                    return _seasonPassFilter(filter.params, participantFields);
                // @@TODO: Should create an array participant.items instead of participant.item
                // case 'dinner':
                //     return dinnerFilter(filter.params, participantFields);
                default:
                    console.log('Filter not configured: ' + filter.id);
            }
            return false;
        }

        // Decide on the correct item for the participant based on priceTable filters
        function getCorrectItem(participantFields, eventId) {
            // If the event is free, we don't need cart items
            var eventConfig = registrationFormService.getCorrectEventConfig(eventId);
            if (eventConfig.isFree) {
                return false;
            }

            var priceTable = eventConfig.priceTable;
            var i;

            // Decide on row
            var row = -1;
            for (i = 0; i < priceTable.rows.length; i++) {
                if (_filterMatches(priceTable.rows[i].filter, participantFields)) {
                    row = i;
                    break;
                }
            }

            // Decide on column
            var col = -1;
            for (i = 0; i < priceTable.columns.length; i++) {
                if (_filterMatches(priceTable.columns[i].filter, participantFields)) {
                    col = i;
                    break;
                }
            }

            // Neither filter matched. Just arrived to page?
            if (row === -1 && col === -1) {
                return false;
            }
            // Fall back to defaults if filters didn't match
            if (row === -1) {
                row = priceTable.defaults.row;
            }
            if (col === -1) {
                col = priceTable.defaults.col;
            }

            return priceTable.items[row][col];
        }

        function getDinnerItem(eventId) {
            var dinner = {};
            var eventConfig = registrationFormService.getCorrectEventConfig(eventId);
            var items = eventConfig.priceTable.items;

            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                if (item[0].id === 'dinner') {
                    return item[0];
                }
            }
        }

        init();

        // Public stuff
        return {
            getCorrectItem: getCorrectItem,
            getDinnerItem: getDinnerItem,
        };
    }
})();

(function() {
    'use strict';

    /*
     *  The point to have this service is to have the token generated already when the user arrives to the payment view.
     *  Then they don't have to wait for it being generated.
     */

    angular.module('wagEventReg').factory('paymentService', PaymentService);

    /** @ngInject */
    function PaymentService(
        $rootScope,
        $state,
        $window,
        gettextCatalog,
        toaster,
        participantService,
        registrationFormService,
        shoppingCart,
        wagApi
    ) {
        var eventConfig = {};
        var uuid = '';

        function init() {
            uuid = angular.fromJson($window.sessionStorage.getItem('uuid')) || '';

            registrationFormService.getEventConfig().then(function(event) {
                eventConfig = event;
            });
        }

        function generateUUID() {
            var d = Date.now();
            if (typeof performance !== 'undefined' && angular.isFunction(performance.now) === 'function') {
                d += performance.now(); //use high-precision timer if available
            }
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
            });
        }

        function getUUID() {
            return uuid;
        }

        function setUpSaferpay(participants) {
            var pathName = $window.location.pathname ? $window.location.pathname : '';
            var baseUrl = $window.location.origin + pathName + '#/';
            if (!baseUrl) {
                var protocol = $window.location.protocol;
                var host = $window.location.host;
                baseUrl = protocol + '//' + host + '/#/';
            }
            var lang = $rootScope.headerLanguage;
            var returnUrls = {
                success: baseUrl + 'thank-you',
                fail: baseUrl + 'register?failed=true',
                abort: baseUrl + 'register?aborted=true',
            };
            uuid = generateUUID();

            wagApi.initWebPayment(shoppingCart.getTotalPrice(), lang, 'Registration payment', uuid, returnUrls).then(
                function(response) {
                    if (response.status !== 'success') {
                        return initWebPaymentFailed(response);
                    }

                    // Store the necessary data for when the payment flow is completed.
                    $window.sessionStorage.setItem('uuid', angular.toJson(uuid));
                    $window.sessionStorage.setItem('cart', angular.toJson(shoppingCart.cart));
                    $window.sessionStorage.setItem('participants', angular.toJson(participants));
                    $window.sessionStorage.setItem('rawParticipants', angular.toJson(participantService.getParticipantsList()));
                    $window.sessionStorage.setItem('sessionTimestamp', angular.toJson(Date.now()));

                    $window.location.assign(response.data.redirectUrl);
                },
                function(response) {
                    return initWebPaymentFailed(response);
                }
            );
        }

        function initWebPaymentFailed(response) {
            toaster.warning({
                title: gettextCatalog.getString('Could not initialise payment. Please try again later.'),
            });
            console.log('initWebPayment failed', response);
            return $state.go('app.register');
        }

        // Get the payment token in the background so it is available quickly when needed.
        init();

        // Public stuff
        return {
            init: init,
            getUUID: getUUID,
            setUpSaferpay: setUpSaferpay,
        };
    }
})();

(function() {
    'use strict';

    angular.module('wagEventReg').factory('participantService', ParticipantService);

    /** @ngInject */
    function ParticipantService(
        $q,
        $rootScope,
        $window,
        gettextCatalog,
        moment,
        priceFilterService,
        registrationFormService,
        shoppingCart,
        wagApi,
        toaster
    ) {
        var participantList = [];
        var extendedParticipantList = []; // Has the items and prices as well
        var eventConfig = {};

        function init() {
            rehydrateAppState();

            registrationFormService.getEventConfig().then(function(event) {
                eventConfig = event;
            });
        }

        init();

        // Public stuff
        return {
            addParticipant: addParticipant,
            emptyParticipantList: emptyParticipantList,
            formatParticipantsForBackend: formatParticipantsForBackend,
            getParticipantsList: getParticipantsList,
            init: init,
            register: register,
            removeParticipant: removeParticipant,
            updateItems: updateItems,
        };

        function addParticipant() {
            var newParticipant = {
                fields: {},
            };
            extendedParticipantList.push(newParticipant);
            participantList.push(newParticipant.fields);
        }

        function formatParticipantsForBackend() {
            var list = [],
                participant;
            for (var i = 0; i < extendedParticipantList.length; i++) {
                participant = angular.copy(extendedParticipantList[i]);

                // Reformat birth date
                if (participant.fields.hasOwnProperty('birthDate')) {
                    participant.fields.birthDate = moment(participant.fields.birthDate, 'DD.MM.YYYY').format('YYYY-MM-DD');
                }

                // Confirm that not waiting list person
                if (participant.fields.email) {
                    list.push(participant);
                }
            }

            return list;
        }

        function getParticipantsList() {
            return participantList;
        }

        // Returns a promise
        function register(totalPrice, paymentNonce) {
            if (participantList.length === 0) {
                console.log('Trying to register with no participants on the list.');
                return $q.reject('Trying to register with no participants on the list.');
            }

            return $q(function(resolve, reject) {
                // Is the event free?
                if (registrationFormService.isFreeEvent()) {
                    wagApi.register(formatParticipantsForBackend()).then(registrationSucceeded, registrationFailed);
                } else {
                    if (typeof totalPrice === 'undefined' || typeof paymentNonce === 'undefined') {
                        return console.log('This is not a free event. Need to pay for it, pal!');
                    }
                    wagApi
                        .register(formatParticipantsForBackend(), totalPrice, paymentNonce)
                        .then(registrationSucceeded, registrationFailed);
                }

                function registrationSucceeded(response) {
                    if (response.status !== wagApi.SUCCESS) {
                        registrationFailed(response);
                        return;
                    }

                    emptyParticipantList();

                    // Show a toaster
                    toaster.success({
                        title: gettextCatalog.getString('Registration successful') + ',',
                        body: gettextCatalog.getString('thank you!'),
                    });

                    resolve(response);
                }

                function registrationFailed(response) {
                    console.log('Registration failed:');
                    console.log(response);

                    toaster.error({
                        title: gettextCatalog.getString('Registration failed') + ',',
                        body: gettextCatalog.getString('please try again.'),
                    });

                    reject(response);
                }
            });
        }

        function emptyParticipantList() {
            // Empty the participant list
            participantList = [];
            extendedParticipantList = [];

            // Empty the cart, too
            shoppingCart.emptyCart();
        }

        // Use stored participant lists if these are available.
        function rehydrateAppState() {
            var sessionTimestamp = angular.fromJson($window.sessionStorage.getItem('sessionTimestamp'));
            var storedParticipants = angular.fromJson($window.sessionStorage.getItem('participants'));
            var storedRawParticipants = angular.fromJson($window.sessionStorage.getItem('rawParticipants'));

            var fifteenMinutesAgo = moment().subtract(15, 'minutes');
            if (moment(sessionTimestamp).isBefore(fifteenMinutesAgo)) {
                console.log('too old session participants');
                return $window.sessionStorage.clear();
            }

            if (validList(storedParticipants) && validList(storedRawParticipants)) {
                // Dates are used in the app in DD.MM.YYYY format. The back end expects dates to be YYYY-MM-DD.
                for (var i = 0; i < storedParticipants.length; i++) {
                    storedParticipants[i].fields.birthDate = storedRawParticipants[i].birthDate;
                    storedParticipants[i].fields.seasonPass = storedRawParticipants[i].seasonPass;
                }

                // @@TODO: Input changes do not project to the correct model after rehydration.
                // Need to disable inputs until resolved.
                $rootScope.inputsDisabled = true;

                participantList = storedRawParticipants;
                extendedParticipantList = storedParticipants;
                // console.log('rehydrated participants');
            }
        }

        // Removes the most recently added person from both participantLists
        function removeParticipant(eventId) {
            if (participantList.length > 1 && extendedParticipantList.length > 1) {
                participantList.pop();
                extendedParticipantList.pop();
                updateItems(eventId);
            }
        }

        function validList(list) {
            return angular.isArray(list) && list.length >= 1;
        }

        // Update all the items
        function updateItems(eventId) {
            var item;
            var itemList = [];

            for (var i = 0; i < extendedParticipantList.length; i++) {
                var fields = extendedParticipantList[i].fields;
                // Find the item based on the price filters
                item = priceFilterService.getCorrectItem(fields, eventId);

                if (item) {
                    extendedParticipantList[i].item = item.id;
                    extendedParticipantList[i].price = item.price;

                    itemList.push(item);
                }

                if (fields.dinner) {
                    var dinnerItem = priceFilterService.getDinnerItem(eventId);
                    itemList.push(dinnerItem);
                }
            }
            // Notify the shopping cart
            shoppingCart.updateCart(itemList);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('wagEventReg')
        // .constant('API_BASE_URL', 'http://localhost:3000/')
        // .constant("API_BASE_URL", "https://wag-api-dev.insidelabs.tech/")
        .constant('API_BASE_URL', 'https://api.laax.com/')
        .constant('EVENT_ID', 'sudden-rush-2019-friday-pro')
        .constant('SECOND_EVENT_ID', 'sudden-rush-2019-friday-masters')
        .constant('THIRD_EVENT_ID', 'sudden-rush-2019-saturday')
        .constant('FOURTH_EVENT_ID', 'sudden-rush-2019-sunday')
        .constant('EVENT_HOME_URL', 'https://www.laax.com/infos/events/suddenrush');
})();

(function() {
    'use strict';

    angular.module('wagEventReg').controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController(
        $location,
        $rootScope,
        $scope,
        $state,
        $window,
        gettextCatalog,
        toaster,
        participantService,
        paymentService,
        registrationFormService,
        shoppingCart,
        wagApi
    ) {
        var vm = this;

        vm.participants = [];
        // Will contain an array of option objects for each of the radio inputs
        vm.radioOptions = {};
        vm.cart = shoppingCart.cart;
        vm.eventConfig = null;
        // vm.soldOut = false;
        vm.isFreeEvent = false;

        vm.addParticipant = addParticipant;
        vm.getMaxParticipants = getMaxParticipants;
        vm.getParticipants = getParticipants;
        vm.isSoldOut = isSoldOut;
        vm.joinWaitingList = joinWaitingList;
        vm.removeParticipant = removeParticipant;
        vm.submit = submit;
        vm.updateCart = updateCart;

        init();

        // $window.onbeforeunload = function(event) {
        //     console.log('event', event);
        // };

        function init() {
            // $window.onpopstate = function(event) {
            //     console.log('onpopstate', event);
            // };
            // console.log('$window.history', $window.history);
            // $scope.$watchCollection('register.participants[0]', function(event) {
            //     console.log('watch participants', event);
            // });

            var urlPath = $location.url();

            // @@TODO: Reset stored session on page reload
            // @@TODO $window.sessionStorage.clear(); if not error? This mean browser "back" won't work.
            if (urlPath.indexOf('aborted=true') !== -1) {
                toaster.warning(gettextCatalog.getString('Payment aborted'));
                // Replace the url to guard against reloads.
                $location.url('/register');
            }

            if (urlPath.indexOf('failed=true') !== -1) {
                toaster.warning(gettextCatalog.getString('Payment failed'));
                // Replace the url to guard against reloads.
                $location.url('/register');
            }

            registrationFormService.getEventConfig().then(function(event) {
                vm.eventConfig = event;
                vm.secondEventConfig = registrationFormService.getSecondEventConfig();
                vm.thirdEventConfig = registrationFormService.getThirdEventConfig();
                vm.fourthEventConfig = registrationFormService.getFourthEventConfig();

                vm.dinnerReservationsString = registrationFormService.getDinnerReservationsString();
                vm.participants = participantService.getParticipantsList();
                // Add the first participant
                if (vm.participants.length === 0) {
                    participantService.addParticipant();
                }
            });
        }

        function addParticipant() {
            participantService.addParticipant();
        }

        function getMaxParticipants(eventId) {
            return registrationFormService.getMaxParticipants(eventId);
        }

        function getParticipants(eventId) {
            return registrationFormService.getParticipants(eventId);
        }

        function isSoldOut(eventId) {
            return registrationFormService.isSoldOut(eventId);
        }

        function joinWaitingList(eventId, person, $index) {
            wagApi.joinWaitingList(eventId, person).then(joinSucceeded, joinFailed);

            function joinSucceeded(response) {
                if (response.status !== 'success') {
                    return joinFailed(response);
                }
                vm.participants[$index].joinedWaitingList = true;

                toaster.success({
                    title: (response.data.name || response.data.email) + ' ' + gettextCatalog.getString('added to the waiting list.'),
                });
            }

            function joinFailed(response) {
                var warningObject = {
                    title: gettextCatalog.getString("Couldn't join the waiting list."),
                };
                if (response.data.errorCode === 156) {
                    warningObject.body = gettextCatalog.getString('There are still open spots for the event.');
                }
                toaster.warning(warningObject);
            }
        }

        function removeParticipant() {
            participantService.removeParticipant();
        }

        function submit() {
            if (!_.isEmpty(vm.eventConfig)) {
                // Is the event free?
                if (vm.eventConfig.isFree) {
                    // We are done here. Let's register.
                    participantService.register().then(function(success) {
                        if (success) {
                            $state.go('app.thankyou');
                        }
                    });
                } else {
                    wagApi
                        .validateRegistration(participantService.formatParticipantsForBackend(), shoppingCart.getTotalPrice())
                        .then(participantSanitationSucceeded, participantSanitationFailed);
                }
            } else {
                console.log('Event config not found');
            }
        }

        function participantSanitationSucceeded(response) {
            if (response.status !== 'success') {
                return participantSanitationFailed(response);
            }

            // setUpSaferpay(response.data);
            $state.go('app.payment', { participants: response.data, fromRegistrationForm: true });
            // paymentService.setUpSaferpay(response.data);
        }

        function participantSanitationFailed(response) {
            // console.log('participantSanitationFailed', response);
            toaster.warning({
                title: gettextCatalog.getString('All required fields are not correct.'),
            });
        }

        // Update cart when something affecting price has changed
        function updateCart(eventId) {
            // @@TODO Set birthDate input to dirty if not correct age.
            // Listeners added in the waInput directive to inputs specified also in waInput
            participantService.updateItems(eventId);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('wagEventReg')
        .controller('PriceGroupsController', PriceGroupsController);

    /** @ngInject */
    function PriceGroupsController($scope, $state, gettextCatalog, registrationFormService, toaster, wagApi) {
        var vm = this;

        vm.person = {};
        vm.priceGroups = {};
        vm.soldOut = false;
        vm.freeEvent = false;
        // Expose uiRouter's $state to the views
        vm.$state = $state;

        vm.joinWaitingList = joinWaitingList;

        init();

        function init() {

            registrationFormService.getEventConfig().then(getEventConfigSucceeded, getEventConfigFailed);

            function getEventConfigSucceeded(response) {
                if (!response) {
                    return getEventConfigFailed(false);
                }
                vm.priceGroups = response.priceTable;
                vm.soldOut = registrationFormService.isSoldOut();
                vm.freeEvent = registrationFormService.isFreeEvent();
            }
            function getEventConfigFailed(response) {
                console.log('getEventConfigFailed, response:', response);
                toaster.error({
                    title: gettextCatalog.getString('Could not load data') + ',',
                    body: gettextCatalog.getString('please try again later.')
                });
            }
        }

        function joinWaitingList() {
            wagApi.joinWaitingList(vm.person).then(joinSucceeded, joinFailed);

            function joinSucceeded(response) {
                // Empty the form
                vm.person = {};
                // Remove the errors from the empty form
                $scope.$$childTail.$$childTail.waitingList.$setPristine();
                $scope.$$childTail.$$childTail.waitingList.$setUntouched();

                toaster.success({
                    title: gettextCatalog.getString('Success!'),
                    body: (response.data.name || response.data.email) + ' ' + gettextCatalog.getString('added to the waiting list.')
                });
            }

            function joinFailed(response) {
                var warningObject = {
                    title: gettextCatalog.getString('Couldn\'t join the waiting list.')
                };
                if (response.data.errorCode === 156) {
                    warningObject.body = gettextCatalog.getString('There are still open spots for the event.')
                }
                toaster.warning(warningObject);
            }
        }
    }

})();

(function() {
    'use strict';

    angular.module('wagEventReg').controller('PaymentController', PaymentController);

    /** @ngInject */
    function PaymentController($location, $state, $stateParams, paymentService, shoppingCart) {
        var vm = this;

        vm.cart = shoppingCart.cart;

        init();

        function init() {
            var urlPath = $location.url();

            // User navigated back from the payment flow using the browser's navigation.
            if (!$stateParams.fromRegistrationForm) {
                return $state.go('app.register');
            }

            paymentService.setUpSaferpay($stateParams.participants);
        }
    }
})();

(function() {
    'use strict';

    angular.module('wagEventReg').controller('MainController', MainController);

    /** @ngInject */
    function MainController($rootScope, EVENT_ID, EVENT_HOME_URL, SECOND_EVENT_ID, THIRD_EVENT_ID, FOURTH_EVENT_ID) {
        // @@TODO: Modified only for Sudden Rush. Change later on
        $rootScope.eventId = EVENT_ID;
        $rootScope.secondEventId = SECOND_EVENT_ID;
        $rootScope.thirdEventId = THIRD_EVENT_ID;
        $rootScope.fourthEventId = FOURTH_EVENT_ID;
        // Not an optimal way to do this, I guess...
        $rootScope.config = {
            EVENT_HOME_URL: EVENT_HOME_URL,
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('wagEventReg')
        .run(runBlock);

    /** @ngInject */
    function runBlock($location, $log, $rootScope, Analytics, gettextCatalog) {
        // Analytics must be injected at least once in the application to enable GA

        $log.debug('runBlock end');

        if ($location.absUrl().indexOf('/en/') !== -1) {
            $rootScope.activeLanguage = 'en_US';
        }
        else {
            $rootScope.activeLanguage = 'de_CH';
        }

        // @@TODO: Hard-coding the language to English due to missing german translations
        // $rootScope.activeLanguage = 'en_US';

        // This way of calling the gettext library can be used to switch language in-app
        gettextCatalog.setCurrentLanguage($rootScope.activeLanguage);
        if ($rootScope.activeLanguage !== 'en_US') {    // No JSON file for english strings needed
            var path = 'translations/' + $rootScope.activeLanguage + '.json'
            gettextCatalog.loadRemote(path);
        }

        $rootScope.headerLanguage = $rootScope.activeLanguage.length >= 2 ? $rootScope.activeLanguage.substring(0, 2) : '';
    }

})();

(function() {
    'use strict';

    angular
        .module('wagEventReg')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($injector, $stateProvider, $urlRouterProvider) {
        $stateProvider

        .state('app', {
            abstract: true,
            // url: '/:eventId?/',
            url: '',
            views: {
                '': {
                    controller: 'MainController',
                    controllerAs: 'main',
                    templateUrl: 'app/main/main.html'
                },
                'upper@app': {
                    templateUrl: 'app/price-groups/price-groups.html',
                    controller: 'PriceGroupsController',
                    controllerAs: 'priceGroups'
                }
            }
        })

        .state('app.register', {
            url: '/register',
            views: {
                'lower': {
                    templateUrl: 'app/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'register'
                }
            }
        })

        .state('app.payment', {
            url: '/payment',
            views: {
                'lower': {
                    templateUrl: 'app/payment/payment.html',
                    controller: 'PaymentController',
                    controllerAs: 'payment'
                }
            },
            params: {
                participants: null,
                fromRegistrationForm: false,
            },
        })

        .state('app.thankyou', {
            url:'/thank-you',
            views: {
                'lower': {
                    templateUrl: 'app/thankyou/thankyou.html',
                    controller: 'ThankYouController',
                    controllerAs: 'thankYou',
                },
            },
        });

        $urlRouterProvider.otherwise('/register');

        // .state('notFound', {
        //     url: '^/notFound',
        //     templateUrl: 'app/404/404.html',
        //     controller: 'MainController',
        //     controllerAs: 'notFound'
        // });


        // $urlRouterProvider.otherwise(function($injector) {
        //     var $state = $injector.get('$state');
        //     var $rootScope = $injector.get('$rootScope');
        //     var $location = $injector.get('$location');

        //     if ($rootScope.eventId) {
        //         // $state.go('app.payment');   // Enable for development purposes
        //         $location.url('/' + $rootScope.eventId + '/register');
        //     }
        //     else {
        //         // $state.go('app.register');   // Enable for development purposes
        //         $state.go('notFound');
        //     }
        // });
    }

})();

/* global malarkey:false, moment:false */
(function() {
    'use strict';

    angular
        .module('wagEventReg')
        .constant('malarkey', malarkey)
        .constant('moment', moment);
})();

(function() {
    'use strict';

    angular
        .module('wagEventReg')
        .config(config);

    /** @ngInject */
    function config(AnalyticsProvider, $logProvider, $mdThemingProvider) {
        // Enable log
        $logProvider.debugEnabled(true);

        var primaryColors = $mdThemingProvider.extendPalette('indigo', {
            '500': '#2F37A4'
        });

        var accent = $mdThemingProvider.extendPalette('light-blue', {
            '500': '#6E74C6'
        });

        var background = $mdThemingProvider.extendPalette('grey', {
            'A100': '#E7ECED'
        });

        $mdThemingProvider.definePalette('sudden-rush-primary', primaryColors);
        $mdThemingProvider.definePalette('sudden-rush-background', background);
        $mdThemingProvider.definePalette('sudden-rush-accent', accent);

        $mdThemingProvider.theme('default')
            .primaryPalette('sudden-rush-primary')
            .accentPalette('sudden-rush-accent')
            .backgroundPalette('sudden-rush-background');

        AnalyticsProvider.setAccount('UA-78350529-4');
        // Change the default page event name.
        // Helpful when using ui-router, which fires $stateChangeSuccess instead of $routeChangeSuccess.
        AnalyticsProvider.setPageEvent('$stateChangeSuccess');
    }

})();

angular.module("wagEventReg").run(["$templateCache", function($templateCache) {$templateCache.put("app/404/404.html","<div><h2>Page not found</h2></div>Temporary helpers:<br><a href=\"/#/sudden-rush-2016/register\">Sudden Rush</a><br><a href=\"/#/random-event-2016/register\">Random Test Event</a>");
$templateCache.put("app/main/main.html","<div><div ui-view=\"nav\"></div><div ui-view=\"upper\"></div><div ui-view=\"lower\"></div></div>");
$templateCache.put("app/payment/payment.html","<div class=\"container payment-view\"><h1 id=\"form-header\" class=\"form-header\" translate=\"\">EVENT REGISTRATION</h1><hr><div class=\"row\"><div class=\"col-xs-12 col-sm-4\"><md-card class=\"payment-view--cart\"><md-card-content><md-list><md-list-item><span class=\"md-title\" translate=\"\">Your order</span></md-list-item><md-list-item ng-show=\"payment.cart.items.length === 0\"><p>-</p></md-list-item><md-list-item ng-repeat=\"item in payment.cart.items\"><p>{{ item.quantity }} x {{ item.label }}</p><span>{{ item.price }} CHF</span></md-list-item><br><md-list-item><strong translate=\"\">Total</strong></md-list-item><md-divider></md-divider><md-list-item><span ng-if=\"payment.cart.totalPrice > 0\">{{ payment.cart.totalPrice }}&nbsp;</span>CHF</md-list-item></md-list></md-card-content></md-card><ul class=\"list-inline credit-cards\"><li><img src=\"assets/images/mastercard.png\" alt=\"MasterCard\"></li><li><img src=\"assets/images/visa.png\" alt=\"Visa\"></li></ul></div></div></div>");
$templateCache.put("app/price-groups/price-groups.html","<div class=\"price-groups\"><div ng-if=\"!priceGroups.freeEvent &amp;&amp; priceGroups.priceGroups.rows\" class=\"container\"><img src=\"assets/images/sudden-rush-banner-2019.png\" alt=\"Sudden Rush\" class=\"center-block price-groups--logo\"><div class=\"price-groups__table\"><table class=\"table table-bordered\"><thead><tr><th></th><th ng-repeat=\"column in priceGroups.priceGroups.columns\">{{ column.label[headerLanguage] }}</th></tr></thead><tbody><tr ng-repeat=\"(index, row) in priceGroups.priceGroups.rows\"><th>{{ row.label[headerLanguage] }}</th><td ng-repeat=\"item in priceGroups.priceGroups.items[index] track by $index\">{{ item.price }} CHF</td></tr><tr><td></td><td colspan=\"2\"><div class=\"price-groups--button-container row\"><img src=\"assets/images/arrow-right.png\" alt=\"Arrow to Book\" class=\"col-xs-3 col-sm-offset-1\"><md-button ng-if=\"priceGroups.$state.is(\'app.register\')\" scroll-to=\"form-header\" duration=\"800\" easing=\"easeInOutCubic\" class=\"md-raised md-primary col-xs-3\">{{ \'Book now!\' | translate }}</md-button><md-button ng-if=\"!priceGroups.$state.is(\'app.register\')\" class=\"md-raised md-primary color-primary col-xs-3\" disabled=\"disabled\">{{ \'Book now!\' | translate }}</md-button><img src=\"assets/images/arrow-left.png\" alt=\"Arrow to Book\" class=\"col-xs-3\"></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/register/register.html","<div class=\"register-view\"><div class=\"container\"><h1 id=\"form-header\" class=\"form-header\" translate=\"\">EVENT REGISTRATION</h1><hr><div class=\"row\" ng-if=\"register.eventConfig\"><form name=\"registrationForm\" id=\"registrationForm\" ng-submit=\"\" novalidate=\"\"><div class=\"registration-form col-sm-12 col-md-8\"><div ng-repeat=\"form in register.participants\"><hr ng-if=\"!$first\"><md-radio-group ng-model=\"form.event\" class=\"md-primary\" ng-required=\"true\" ng-change=\"register.updateCart(form.event)\"><label><span>*</span>{{ \'Day of event\' | translate }}</label><md-radio-button ng-disabled=\"inputsDisabled\" ng-value=\"eventId\">{{ \'Friday (18 and older)\' | translate }} - Pro</md-radio-button><md-radio-button ng-disabled=\"inputsDisabled\" ng-value=\"secondEventId\">{{ \'Friday (18 and older)\' | translate }} - Masters</md-radio-button><md-radio-button ng-disabled=\"inputsDisabled\" ng-value=\"thirdEventId\">{{ \'Saturday (18 and older)\' | translate }} - Open</md-radio-button><md-radio-button ng-disabled=\"inputsDisabled\" ng-value=\"fourthEventId\">{{ \'Sunday (Juniors & Kids)\' | translate }}</md-radio-button></md-radio-group><div ng-if=\"form.event\" class=\"row registered-amount__container\"><div class=\"col-xs-12\"><strong class=\"registered-amount__count\">{{ \'Available starting spots\' | translate }} {{ register.getMaxParticipants(form.event) - register.getParticipants(form.event) }} / {{ register.getMaxParticipants(form.event) }}</strong></div></div><strong ng-if=\"form.joinedWaitingList\" class=\"padding-horizontal\" translate=\"\">Joined waiting list.</strong><md-card class=\"waiting-list\" ng-if=\"form.event &amp;&amp; register.isSoldOut(form.event) &amp;&amp; !form.joinedWaitingList\"><md-card-content><p ng-if=\"!form.joinedWaitingList\" class=\"padding-horizontal\" translate=\"\">Enter your name and e-mail address to be the first to hear when places become available.</p><div ng-if=\"!form.joinedWaitingList\" class=\"waiting-list--input\"><md-input-container><label for=\"name\">{{ \'Name\' | translate }}</label> <input ng-model=\"register.waitingListPerson[$index].name\" type=\"text\" name=\"name\" id=\"name\" class=\"md-input\" md-maxlength=\"50\"></md-input-container><md-input-container><label for=\"email\"><span>*</span>{{ \'E-mail address\' | translate }}</label> <input ng-model=\"register.waitingListPerson[$index].email\" type=\"email\" name=\"email\" id=\"email\" class=\"md-input\" required=\"required\"></md-input-container></div></md-card-content><md-card-actions ng-if=\"!form.joinedWaitingList\" layout=\"row\" layout-align=\"start center\" layout-padding=\"\"><md-button form=\"waitingList\" class=\"md-raised md-primary color-primary\" style=\"max-width: 250px;\" layout-fill=\"\" ng-disabled=\"!register.waitingListPerson[$index].email\" ng-click=\"register.joinWaitingList(form.event, register.waitingListPerson[$index], $index)\">{{ \'Join waiting list\' | translate }}</md-button></md-card-actions></md-card><div ng-if=\"form.event === eventId &amp;&amp; !register.isSoldOut(form.event)\" class=\"registration-form--input row\"><wa-input formid=\"registrationForm\" ng-repeat=\"input in register.eventConfig.inputs\" class=\"col-xs-6\" ng-model=\"input\" form-index=\"{{$parent.$parent.$index}}\" ng-class=\"{\'half-width\': input.id===\'birthDate\', \'full-width\': input.id===\'dinner\'}\"></wa-input></div><div ng-if=\"form.event === secondEventId &amp;&amp; !register.isSoldOut(form.event)\" class=\"registration-form--input row\"><wa-input formid=\"registrationForm\" ng-repeat=\"input in register.secondEventConfig.inputs\" class=\"col-xs-6\" ng-model=\"input\" form-index=\"{{$parent.$parent.$index}}\" ng-class=\"{\'half-width\': input.id===\'birthDate\', \'full-width\': input.id===\'dinner\'}\"></wa-input></div><div ng-if=\"form.event === thirdEventId &amp;&amp; !register.isSoldOut(form.event)\" class=\"registration-form--input row\"><wa-input formid=\"registrationForm\" ng-repeat=\"input in register.thirdEventConfig.inputs\" class=\"col-xs-6\" ng-model=\"input\" form-index=\"{{$parent.$parent.$index}}\" ng-class=\"{\'half-width\': input.id===\'birthDate\', \'full-width\': input.id===\'dinner\'}\"></wa-input></div><div ng-if=\"form.event === fourthEventId &amp;&amp; !register.isSoldOut(form.event)\" class=\"registration-form--input row\"><wa-input formid=\"registrationForm\" ng-repeat=\"input in register.fourthEventConfig.inputs\" class=\"col-xs-6\" ng-model=\"input\" form-index=\"{{$parent.$parent.$index}}\" ng-class=\"{\'half-width\': input.id===\'birthDate\', \'full-width\': input.id===\'dinner\'}\"></wa-input></div></div><div class=\"row\"><md-button ng-click=\"register.addParticipant()\" class=\"col-xs-12 col-sm-5 md-raised md-primary\" style=\"max-width: 250px;\" ng-disabled=\"inputsDisabled || register.participants.length === 5\">{{ \'Add another person\' | translate }}</md-button><md-button ng-click=\"register.removeParticipant(form.event)\" class=\"col-xs-12 col-sm-5 md-primary\" style=\"max-width: 250px;\" ng-disabled=\"inputsDisabled || register.participants.length === 1\">{{ \'Remove person\' | translate }}</md-button></div></div></form><div class=\"col-sm-12 col-md-4 sticky\"><md-card class=\"register-view--cart\"><md-card-content><md-list><md-list-item><span class=\"md-title\" translate=\"\">Your order</span></md-list-item><md-list-item ng-show=\"register.cart.items.length === 0\"><p>-</p></md-list-item><md-list-item ng-repeat=\"item in register.cart.items\"><p>{{ item.quantity }} x {{ item.label }}</p><span style=\"padding-left: 3px;\">{{ item.price }} CHF</span></md-list-item><br><md-list-item><strong translate=\"\">Total</strong></md-list-item><md-divider></md-divider><md-list-item><span ng-if=\"register.cart.totalPrice > 0\">{{ register.cart.totalPrice }}&nbsp;</span>CHF</md-list-item><strong class=\"description-text\" translate=\"\">Be aware: The price is based on your date of birth.</strong></md-list></md-card-content><md-card-actions layout=\"row\" layout-align=\"center center\" layout-padding=\"\"><md-button ng-click=\"register.submit()\" class=\"md-raised color-secondary\" style=\"max-width: 350px;\" ng-disabled=\"registrationForm.$invalid\" layout-fill=\"\" aria-label=\"Proceed to payment\"><span ng-if=\"register.isFreeEvent\">{{ \'Confirm registration\' | translate }}</span> <span ng-if=\"!register.isFreeEvent\">{{ \'Proceed to payment\' | translate }}</span></md-button></md-card-actions></md-card></div></div></div></div>");
$templateCache.put("app/thankyou/thankyou.html","<div class=\"thankyou-view\"><div class=\"container text-center\"><h1 class=\"form-header\" translate=\"\">Registration successful. Thank You!</h1><hr><h5 class=\"form-header\" translate=\"\">You should receive a confirmation e-mail in a few minutes.</h5><p><md-button ng-href=\"{{config.EVENT_HOME_URL}}\" class=\"col-xs-12 col-sm-5 md-raised md-primary\" style=\"float: none; max-width: 250px;\">{{\'Back to home\' | translate}}</md-button></p></div></div>");}]);